import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0df8173e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "log-msg-page" }
const _hoisted_2 = { class: "auto-fetch" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "new-tip" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "new ws_mr15" }, "NEW"),
  /*#__PURE__*/_createElementVNode("span", null, "1分钟内更新的数据")
], -1))
const _hoisted_4 = { class: "switch" }
const _hoisted_5 = { class: "ws_common_table" }
const _hoisted_6 = { class: "new-tip" }
const _hoisted_7 = {
  key: 0,
  class: "new"
}
const _hoisted_8 = { class: "log-id ws_text_overflow" }
const _hoisted_9 = { class: "log-content" }
const _hoisted_10 = { class: "ws_text_overflow ws_mr4" }
const _hoisted_11 = { class: "log-content" }
const _hoisted_12 = { class: "ws_text_overflow ws_mr4" }
const _hoisted_13 = ["onClick"]

import { onMounted, ref, watch, onUnmounted } from 'vue'
import { Search, Tickets, QuestionFilled } from '@element-plus/icons-vue'
import { queryDeviceLogPage, exportDeviceLog } from '@/api'
import { PAGE_SIZES, CODE_ENUM, MSG_TRANSFER_TYPE } from '@/common'
import { isEmpty } from 'lodash'
import moment from 'moment'
import LogInfo from './components/log-info.vue'
import { transformLogContent, downLoadFile, formatFormTime } from '@/utils'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import TypeSelect from '@/components/type-select'
import Selecttenant from '@/components/select-tenant'
import SelectDevice from '@/components/select-device'
import { ElMessage } from 'element-plus'
import { useMsgStore } from '@/stores/msg'
import LogSource from './components/log-source.vue'

const EVENT_REPORT_CODE = '1003'


export default /*#__PURE__*/_defineComponent({
  __name: 'log',
  setup(__props) {

const megStore = useMsgStore()

megStore.queryLogType()

const advancedRef = ref()

const isNew = (timeStemp: number) => {
  return new Date().getTime() - timeStemp < 1000 * 60
}

const sortParams: any = ref({})
const sortChange = ({ prop, order }: any) => {
  sortParams.value = {
    prop,
    order,
  }
  fetchList()
}

const getSortKey = () => {
  const { order, prop } = sortParams.value || {}
  if (order) {
    const key = order === 'ascending' ? 'asc' : 'desc'
    return {
      [key]: prop,
    }
  }
}

const formatterSatelliteTime = (satelliteTime: any) => {
  return satelliteTime
    ? moment(satelliteTime).format('YYYY-MM-DD HH:mm:ss')
    : '-'
}

// 事件上报
const tableData: any = ref([])
const formInline = ref({
  orgId: undefined,
  // deviceId: undefined,
  deviceName: '',
  deviceSn: '',
  logId: '',
  logType: '',
  transType: '',
  satelliteId: '',
  collectTime: [],
  createTime: [],
})

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

// 自动刷新
const autoFetch = ref(false)
const timer: any = ref(0)
watch(autoFetch, () => {
  if (autoFetch.value) {
    clearInterval(timer.value)
    timer.value = setInterval(() => {
      fetchList()
    }, 5000)
  } else {
    clearInterval(timer.value)
  }
})

onUnmounted(() => {
  clearInterval(timer.value)
})

// 租户改变，清除
const orgChange = () => {
  formInline.value = {
    ...formInline.value,
    // deviceId: undefined,
  }
}

const handleSizeChange = (pageSize: number) => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = (pageSize: number) => {
  fetchList()
}
const tableLoading = ref(false)

const getMoTime = (keepAliveData: any) => {
  return {
    ...formatFormTime(keepAliveData.collectTime, [
      'collectStartTime',
      'collectEndTime',
    ]),
    // ...formatFormTime(keepAliveData.createTime, [
    //   'createStartTime',
    //   'createEndTime',
    // ]),
    ...formatFormTime(keepAliveData.createTime, [
      'satelliteStartTime',
      'satelliteEndTime',
    ]),
  }
}

const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData() || {}

  const moTime = getMoTime(keepAliveData)
  const { data, reset } = queryData || {}
  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true
  const res: any = await queryDeviceLogPage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
    ...moTime,
    ...getSortKey(),
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(() => {
  fetchList()
})

// 特殊字段处理
const formatterMap = {
  prodDate: (value: string) => {
    return moment(Number(value)).format('YYYY-MM-DD HH:mm:ss')
  },
  location: (value: string) => {
    // console.log(value, 'value')
    const result: any = JSON.parse(value)
    const { latitude, longitude } = result
    return '经度' + longitude + ' ' + '纬度' + latitude
  },
  logDate: (value: string) => {
    return moment(Number(value)).format('YYYY-MM-DD HH:mm:ss')
  },
  tleLastTime: (value: string) => {
    return moment(Number(value)).format('YYYY-MM-DD HH:mm:ss')
  },
}

const filterAttr = ['prodDate', 'logDate']
const formatterLogContent = (attrList: any) => {
  return transformLogContent(attrList, formatterMap)
    .map(({ label, value, key }: any) => {
      return filterAttr.includes(key) ? '' : label + ' : ' + value
    })
    .filter(Boolean)
    .join('；')
}

const detailModal = ref({
  rowData: {},
  visible: false,
})

const showLogDetail = (row: any) => {
  detailModal.value = {
    visible: true,
    rowData: row,
  }
}

const exportLog = async () => {
  const keepAliveData = advancedRef.value.getKeepAliveData() || {}
  const moTime = getMoTime(keepAliveData)

  const res: any = await exportDeviceLog({
    ...keepAliveData,
    ...moTime,
    ...getSortKey(),
  })
  if (res?.msg?.code === CODE_ENUM.SUCCESS) {
    downLoadFile(res)
  } else {
    ElMessage.error(res?.msg?.msg)
  }
}

const formatterSatelliteId = (row: any) => {
  return row.satelliteId || '-'
}

const linkConf = ref({
  data: {},
  visible: false,
})

const showLinkLogDetail = (row: any) => {
  linkConf.value = {
    visible: true,
    data: row,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AdvancedQueryLayout), {
        class: "advance-container",
        ref_key: "advancedRef",
        ref: advancedRef,
        model: formInline.value,
        onFetchList: fetchList,
        "btn-span": 24
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "租户",
            prop: "orgId"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Selecttenant), {
                "show-type": true,
                modelValue: formInline.value.orgId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.orgId) = $event)),
                onChange: orgChange
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "设备名称",
            prop: "deviceName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.deviceName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.deviceName) = $event)),
                clearable: "",
                maxlength: "50",
                class: "ws_select",
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "日志ID",
            prop: "logId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.logId,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInline.value.logId) = $event)),
                clearable: "",
                maxlength: "50",
                class: "ws_select",
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "设备SN",
            prop: "deviceSn"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.deviceSn,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formInline.value.deviceSn) = $event)),
                clearable: "",
                maxlength: "50",
                class: "ws_select",
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "消息来源",
            prop: "transType"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TypeSelect), {
                modelValue: formInline.value.transType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formInline.value.transType) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "卫星ID",
            prop: "satelliteId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.satelliteId,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formInline.value.satelliteId) = $event)),
                clearable: "",
                maxlength: "50",
                class: "ws_select",
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "日志类型",
            prop: "logType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formInline.value.logType,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formInline.value.logType) = $event)),
                clearable: "",
                filterable: "",
                class: "ws_select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(megStore).msgLogType, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.code,
                      label: item.name,
                      value: item.code
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "采集时间",
            prop: "collectTime",
            class: "ws_time_range collect-time"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: formInline.value.collectTime,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formInline.value.collectTime) = $event)),
                "unlink-panels": "",
                type: "datetimerange",
                "range-separator": "-",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                editable: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "星上时间",
            prop: "createTime",
            class: "ws_time_range create-time"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: formInline.value.createTime,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formInline.value.createTime) = $event)),
                "unlink-panels": "",
                type: "datetimerange",
                "range-separator": "-",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                editable: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_switch, {
            modelValue: autoFetch.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((autoFetch).value = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("span", {
            class: _normalizeClass(["ws_ml5 ws_mr5", { active: autoFetch.value }])
          }, "自动刷新", 2),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: "每五秒自动刷新一次",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionFilled))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: exportLog,
            class: "ws_ml16",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          class: "ws_mt20",
          stripe: "",
          onSortChange: sortChange
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, { description: "暂无数据" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "orgName",
              label: "租户名称",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "logId",
              label: "日志ID",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_6, [
                  (isNew(scope.row.createTime))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "new"))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(scope.row.logId), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "deviceName",
              label: "设备名称",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "logType",
              label: "日志类型"
            }),
            _createVNode(_component_el_table_column, {
              prop: "logContent",
              label: "日志内容",
              "min-width": "350",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(scope.row.formatType === _unref(MSG_TRANSFER_TYPE).JSON
                  ? formatterLogContent(scope.row.attrList)
                  : scope.row.logContent), 1),
                  (scope.row.formatType === _unref(MSG_TRANSFER_TYPE).JSON)
                    ? (_openBlock(), _createBlock(_component_el_icon, {
                        key: 0,
                        onClick: ($event: any) => (showLogDetail(scope.row)),
                        class: "icon"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Tickets))
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "transType",
              label: "消息来源"
            }),
            _createVNode(_component_el_table_column, {
              formatter: formatterSatelliteId,
              prop: "satelliteId",
              label: "卫星ID"
            }),
            _createVNode(_component_el_table_column, {
              prop: "prodTime",
              label: "采集时间",
              width: "200",
              sortable: "custom"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_unref(moment)(scope.row.prodTime).format('YYYY-MM-DD HH:mm:ss')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "satelliteTime",
              label: "星上时间",
              width: "200",
              sortable: "custom"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(formatterSatelliteTime(scope.row.satelliteTime)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "createDate",
              label: "上报时间",
              width: "200",
              sortable: "custom"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_unref(moment)(scope.row.createDate).format('YYYY-MM-DD HH:mm:ss')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "parseStatusValue",
              "show-overflow-tooltip": "",
              label: "解析状态",
              width: "150"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(scope.row.parseStatusValue), 1),
                  _createElementVNode("span", {
                    class: "icon icon-link",
                    onClick: ($event: any) => (showLinkLogDetail(scope.row))
                  }, null, 8, _hoisted_13)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[10] || (_cache[10] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[11] || (_cache[11] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ])
    ]),
    _createVNode(LogInfo, {
      visible: detailModal.value.visible,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((detailModal.value.visible) = $event)),
      rowData: detailModal.value.rowData,
      formatterMap: formatterMap
    }, null, 8, ["visible", "rowData"]),
    _createVNode(LogSource, {
      visible: linkConf.value.visible,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((linkConf.value.visible) = $event)),
      data: linkConf.value.data
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})